// Selo "Sandbox" no cabecalho: a instancia se identifica pelo HOSTNAME, em runtime.
//
// Antes vinha de `configs.env === "homol"`, escolhido em tempo de BUILD — e o Dockerfile
// copia `configs-prod.js`. Resultado medido em 14/09/2026: a homolog nova da Magalu subiu
// SEM o selo, servindo uma copia integral do banco de producao e sem nada na tela dizendo
// que nao era producao. Trocar para `configs-homol.js` nao servia: ele tambem forca `http://`
// em 5 telas de status, e essa homolog tem certificado valido.
//
// Mesma razao pela qual `setApiRoutes` ja deriva a URL da API do hostname: um build so serve
// qualquer instancia.
//
// A regra e A PROVA DE FALHA: e sandbox a menos que o hostname esteja na lista de producao.
// Ambiente novo ou desconhecido mostra o selo. Mostrar o selo em producao por engano e
// constrangedor; esconder em homologacao faz alguem tratar dado de teste como real.

const PRODUCAO = ["atlas.atmodigital.com", "atlas-subway.atmodigital.com"];

export default function isSandbox() {
  return !PRODUCAO.includes(window.location.hostname);
}
